<div class="odjeli-page">

    <div class="odjeli-page__container">
        <odjeli-tablica *ngIf="odjeli" [odjeli]="odjeli"></odjeli-tablica>
    </div>

</div>